import React from "react";
import Fade from "react-reveal/Fade";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Navigation } from "swiper";

import { ReactComponent as ArrowLeft } from "../../../assets/img/icons/arrow-circle-left.svg";
import { ReactComponent as ArrowRight } from "../../../assets/img/icons/arrow-circle-right.svg";
import "../../../scss/swiper.min.css";
import "./_home-product.scss";

SwiperCore.use(Navigation);

const HomeProductSlider = ({ home: { home } }) => (
  <>
    {home && home.slider && home.slider.length > 0 && (
      <div className="home-product-wrap">
        <Fade>
          <div className="slider-wrap">
            <Swiper
              spaceBetween={0}
              slidesPerView={1}
              speed={900}
              autoHeight={true}
              navigation={{
                nextEl: ".product-arrow-right",
                prevEl: ".product-arrow-left",
              }}
              className="home-product-slider"
            >
              {home.slider.map((item, key) => (
                <SwiperSlide key={key}>
                  <div className="home-product-slide-box">
                    <picture>
                      <source srcSet={item.mobile_background_image} media="(max-width: 767px)" />
                      <img src={item.background_image} alt="" />
                    </picture>
                    <div className="overlay-content">
                      <div className="content">
                        <h2 className="h2">{item.title}</h2>
                        <a
                          href={item.link}
                          className="btn btn-outline-secondary"
                        >
                          {item.link_text}
                        </a>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
            <div className="slider-arrow">
              <button
                type="button"
                className="block-slider-arrow block-slider-arrow--left product-arrow-left"
              >
                <ArrowLeft />
              </button>
              <button
                type="button"
                className="block-slider-arrow block-slider-arrow--right product-arrow-right"
              >
                <ArrowRight />
              </button>
            </div>
          </div>
        </Fade>
      </div>
    )}
  </>
);

export default HomeProductSlider;
